
export default {
  props: {
    fixture: {
      type: Object,
      required: true,
    },
  },
  inject: [`refresh`, `lastUpdated`],
  data () {
    return {
      tabs: [`Pitch View`, `Lineup View`],
      currentTab: `Lineup View`,
      formations: {
        home: null,
        away: null,
      },
      formationRefreshInterval: null,
    };
  },
  computed: {
    showFormationTab () {
      return this.formations.home && this.formations.away;
    },
    homeTeam () {
      return this.getTeam(this.fixture);
    },
    awayTeam () {
      return this.getTeam(this.fixture, `Away`);
    },
  },
  mounted () {
    this.getFormations(true);

    if (this.refresh) {
      this.formationRefreshInterval = setInterval(() => {
        this.getFormations();
      }, this.refresh);
    }
  },
  beforeDestroy () {
    if (this.formationRefreshInterval) {
      clearInterval(this.formationRefreshInterval);
    }
  },
  methods: {
    setTab (tab) {
      this.currentTab = tab;
    },
    getFormations (firstLoad = false) {
      this.getFormation(this.homeTeam, `home`, firstLoad);
      this.getFormation(this.awayTeam, `away`, firstLoad);
    },
    async getFormation (team, side, firstLoad = false) {
      const params = {
        include: `formation`,
      };

      const request = await this.$getStats(`fixtureTeam/${team.id}`, params);
      if (request.data.formation !== null) {
        this.formations[side] = request.data.formation?.name;
      }

      if (this.formations.home && this.formations.away && firstLoad) {
        this.currentTab = `Pitch View`;
      }
    },
  },
};
